import { AltUnit } from '../../order-builder/modules/specification/models/units';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';
import { OneClickUnitsActions, OneClickUnitsActionTypes } from '../actions/one-click-units.actions';

export interface OneClickUnitsState {
  loading: boolean;
  unitsAvailable: AltUnit[];
  selected: AltUnit;
}

export const initialState: OneClickUnitsState = {
  loading: false,
  unitsAvailable: [],
  selected: null,
};

export function reducer(
  state = initialState,
  action: OneClickUnitsActions | OneClickProfileActions,
): OneClickUnitsState {
  switch (action.type) {
    case OneClickUnitsActionTypes.LOAD_UNITS: {
      return {
        ...state,
        loading: true,
      } as OneClickUnitsState;
    }
    case OneClickUnitsActionTypes.LOAD_UNITS_COMPLETE: {
      return {
        ...state,
        loading: false,
        unitsAvailable: [...action.payload],
      } as OneClickUnitsState;
    }
    case OneClickUnitsActionTypes.SELECT_UNITS: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickUnitsState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickUnitsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
